import React from "react";
import { useSelector } from "react-redux";
import A from "../../../../../../../common/A";

const Tabs = ( props ) => {

  const keypad = useSelector( state => state.keypad );

  return (
    <ul className="tablist">
      <li><A index="0" className={ '0' === keypad.tabIndex ? 'active' : null } onClick={ props.onTab }>123</A></li>
      <li><A index="1" className={ '1' === keypad.tabIndex ? 'active' : null } onClick={ props.onTab }>Aa</A></li>
    </ul>
  );

};

export default Tabs;
